import { useState } from "react";
import { Form, Input, DatePicker, Button, Card } from "antd";
import { Editor } from "@tinymce/tinymce-react";
import dayjs from "dayjs";

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;

const Admin = () => {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState(null);
  const [editorContent, setEditorContent] = useState("");
  const [password, setPassword] = useState("");
  const [allow, setAllow] = useState(false);

  const handleSubmit = (values) => {
    const formattedDate = values.date
      ? dayjs(values.date).format("DD-MM-YYYY")
      : null;
    const data = { ...values, date: formattedDate, detail: editorContent };
    setFormData(data);
  };

  const handleCopy = () => {
    if (formData) {
      navigator.clipboard.writeText(JSON.stringify(formData, null, 2));
    }
  };

  const handleSavePassword = () => {
    sessionStorage.setItem("adminPassword", password);

    const savedPassword = sessionStorage.getItem("adminPassword");
    setAllow(savedPassword === ADMIN_PASSWORD);
  };

  if (!allow) {
    return (
      <div
        style={{
          maxWidth: "500px",
          margin: "20px auto",
          height: "100dvh",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Input
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="primary" onClick={handleSavePassword}>
          Login
        </Button>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: 1000,
        margin: "20px auto",
        gap: "20px",
        display: "flex",
      }}
    >
      <div style={{ flex: 1 }}>
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: "Title is required" }]}
          >
            <Input placeholder="Enter title" />
          </Form.Item>

          <Form.Item
            label="Detail"
            name="detail"
            rules={[{ required: true, message: "Detail is required" }]}
          >
            <Editor
              apiKey={process.env.REACT_APP_TINY_KEY}
              initialValue=""
              init={{
                height: 500,
                menubar: true,
                plugins:
                  "advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste help wordcount",
                toolbar:
                  "undo redo | formatselect | fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help",
              }}
              onEditorChange={(content) => setEditorContent(content)}
            />
          </Form.Item>

          <Form.Item
            label="Date"
            name="date"
            rules={[{ required: true, message: "Date is required" }]}
          >
            <DatePicker style={{ width: "100%" }} format="DD-MM-YYYY" />
          </Form.Item>

          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
        <Button onClick={handleCopy} style={{ marginTop: 10 }}>
          Copy to Clipboard
        </Button>
      </div>
      {formData && (
        <Card title="Submitted Data" style={{ marginTop: 20, flex: 1 }}>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {JSON.stringify(formData, null, 2)}
          </pre>
        </Card>
      )}
    </div>
  );
};

export default Admin;
